<template>
  <el-form ref="appsetting" :model="{}" :rules="rules" label-width="140px" v-if="outterForm">
    <el-form-item label="投放位置">
      <Mixcheck v-model="outterForm.union">
        <radio-item :label="0" disabled>默认</radio-item>
        <radio-item :label="1" disabled>快手投放联盟</radio-item>
      </Mixcheck>
    </el-form-item>

    <template v-if="isLink">
      <el-form-item label="投放类型">
        <el-radio-group disabled v-model="innerForm.promoted_type" type="button">
          <el-radio-button ghost :label="0">落地页</el-radio-button>
          <el-radio-button ghost :label="1">预约投放</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <template v-if="innerForm.promoted_type === 1">
        <el-form-item label="预约落地页">
          <el-radio-group disabled v-model="outterForm.site_type">
            <el-radio-button ghost :label="1">IOS预约</el-radio-button>
            <el-radio-button ghost :label="2">安卓预约</el-radio-button>
          </el-radio-group>

          <div style="margin-top: 10px">
            <el-select v-model="outterForm.site_id" style="width: 220px" placeholder="请选择预约落地页">
              <el-option v-for="item in landPageList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </el-form-item>
      </template>

      <template v-if="innerForm.promoted_type === 0">
        <el-form-item label="推广落地页" prop="landingPage">
          <RadioGroup v-model="outterForm.page_type_custom" type="button">
            <Radio :label="1" :disabled="editState">快手建站落地页</Radio>
            <Radio :label="2" :disabled="editState || isMiniGame">平头哥落地页</Radio>
          </RadioGroup>

          <div style="margin-top: 10px" v-if="outterForm.page_type_custom === 1">
            <page-select @on-select="pageModal = true" :urls="outterForm.externalUrls" :type="pageType"> </page-select>
          </div>

          <div style="margin-top: 10px" v-if="outterForm.page_type_custom === 2">
            <Button type="primary" @click="linkModel = true">选择平头哥落地页</Button>
            <span v-if="innerForm.land_page_id" style="margin-left: 20px">
              已选落地页ID：
              <span style="color: red">{{ innerForm.land_page_id }} </span>
            </span>
          </div>
        </el-form-item>
      </template>
    </template>

    <!-- 应用下载 -->
    <template v-else>
      <el-form-item label="应用类型" v-if="innerForm.ch_platform_id === KuaiShou.GAME_PLATFORM.ANDROID">
        <Input value="Android应用下载" disabled style="width: 400px" />
      </el-form-item>

      <template v-if="isAndroid">
        <el-form-item label="应用名称">
          <input-len v-model="innerForm.app_name" placeholder="最大100个字符，1个中文等于2个字符" width="398" :max="100" />
          <p style="color: #ff0000; margin-bottom: 0; font-size: 12px; margin-top: 5px">
            注意：该处的名字对应的是媒体后台应用名称，有多余的文字请记得手动删除掉
          </p>
        </el-form-item>
        <el-form-item label="应用包名">
          <Input v-model="innerForm.package" placeholder="应用包名根据选择游戏自动获取" style="width: 398px" disabled />
        </el-form-item>
        <el-form-item label="应用图标">
          <img v-if="innerForm.app_ids" :src="innerForm.iconUrl" width="64px" height="64px" />
          <div v-else style="background-color: #ccc; border-radius: 4px; width: 64px; height: 64px"></div>
        </el-form-item>
        <el-form-item label="是否接入快手SDK">
          <i-Switch v-model="innerForm.use_sdk" :true-value="1" :false-value="0" />
        </el-form-item>
      </template>

      <!-- ios -->
      <el-form-item label="选择已有应用" v-if="isIOS && innerForm.app_ids">
        <el-input :value="innerForm.app_ids[0].real_app_name" disabled style="width: 280px"></el-input>
        <!-- <Select v-model="innerForm.app_id" placeholder="请选择应用" disabled style="width: 358px">
          <Option v-for="app in innerForm.app_ids[0].iOSAppData" :key="app.app_id" :value="app.app_id" :label="app.real_app_name" />
        </Select> -->
      </el-form-item>
    </template>

    <el-form-item label="搭配试玩">
      <RadioGroup v-model="outterForm.playable" type="button" @on-change="handlePlayable">
        <Radio :label="0">不启用</Radio>
        <Radio :label="1">启用</Radio>
      </RadioGroup>
    </el-form-item>
    <el-form-item label="选择试玩" v-if="outterForm.playable" prop="playable_id">
      <Select v-model="outterForm.playable_id" placeholder="全部" style="width: 358px">
        <Option v-for="app in playList" :key="app.id" :value="app.id" :label="app.name" />
      </Select>
    </el-form-item>
    <el-form-item label="试玩按钮" v-if="outterForm.playable" prop="play_button">
      <Select v-model="outterForm.play_button" placeholder="请选择试玩按钮" style="width: 358px">
        <Option v-for="(item, id) in playBtns" :key="id" :value="item" :label="item" />
      </Select>
    </el-form-item>
    <el-form-item label="投放方式">
      <el-radio-group disabled v-model="formData.deliveryMethod">
        <el-radio-button ghost :label="1">手动投放</el-radio-button>
        <!-- <el-radio-button ghost :label="2">智能操盘</el-radio-button> -->
        <el-radio-button ghost :label="3">全自动投放</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item v-show="formData.deliveryMethod === 2">
      <span slot="label">
        <Tooltip placement="top" max-width="300">
          <span style="position: top:-3px;">自动调控<i class="el-icon-info"></i></span>
          <div slot="content">
            <p>系统将会进行如下调控：</p>
            <p>·自动关停效果不佳的计划;</p>
            <p>·基于设置的定向，探索优质人群;</p>
            <p>·自动调整投放时段，选择更合适的投放时段;</p>
            <p>·自动调配组预算，降低空耗，计划预算不会被突破;</p>
          </div>
        </Tooltip>
      </span>
      <i-switch disabled :value="true"></i-switch>
    </el-form-item>

    <!-- 快手建站落地页 -->
    <KuaishouLandingPage
      v-model="pageModal"
      :accounts="accounts"
      :filter="false"
      :page-type="outterForm.union"
      :type="pageType"
      @on-select="selectAccount"
      @on-close="closePage"
    >
    </KuaishouLandingPage>

    <!-- 平头哥落地页 -->
    <PTGlandingPage v-model="linkModel" @on-select="selectLinkLandPage"></PTGlandingPage>
  </el-form>
</template>
<script>
import InputLen from '@/components/input/input-len'
import Mixcheck from '@/components/mixcheck'
import RadioItem from '@/components/mixcheck/radio-item'
import PageSelect from '@/components/page-select/page-select.vue'
import KuaishouLandingPage from '@/components/page-select/page-data.vue'
import PTGlandingPage from '@/components/landpage/landpage.vue'
import { makeAppSettingRules } from './data/form-rules.js'
import { getPlayButtons, getPlayLists, getAllPagesByAccount } from '@/api/kuaishou.model'
import { isArray } from '@/common/js/utils'
import KuaiShou from './data/index.class'

export default {
  components: { InputLen, Mixcheck, RadioItem, PageSelect, KuaishouLandingPage, PTGlandingPage },
  props: {},
  computed: {
    KuaiShou() {
      return KuaiShou
    },
    editState() {
      return this.$route.path.includes('/edit/')
    },
    taskInfo() {
      return this.$store.state.Kuaishou.taskInfo
    },
    formData() {
      return this.$store.getters['Kuaishou/currTaskParams']
    },
    outterForm: {
      get() {
        return this.formData.outterForm
      },
      set(v) {
        this.$store.commit('Kuaishou/UPDATE_OUT_PARAMS', v)
      }
    },
    innerForm: {
      get() {
        return this.formData.innerForm
      },
      set(v) {
        this.$store.commit('Kuaishou/UPDATE_INNER_PARAMS', v)
      }
    },
    isAndroid() {
      return this.innerForm.ch_platform_id === 1
    },
    isIOS() {
      return this.innerForm.ch_platform_id === 2
    },
    isMiniGame() {
      return this.innerForm.ch_platform_id === 3
    },
    isLink() {
      return this.innerForm.landing_type === 'LINK'
    },
    accounts() {
      const { ad_account_id: id, ad_account_name: name } = this.formData
      return [{ id, name }]
    },
    pageType() {
      return this.outterForm.page_type_custom === 1 ? 'kuaishou' : 'ptg'
    }
  },
  data() {
    return {
      rules: { ...makeAppSettingRules.call(this) },
      pageModal: false,
      linkModel: false,
      playBtns: [],
      playList: [],
      landPageList: []
    }
  },
  methods: {
    preLoadData() {
      const param = { ad_account_id: this.formData.ad_account_id }
      Promise.all([getPlayButtons(param), getPlayLists(param), getAllPagesByAccount(param)])
        .then((data) => {
          const [btns, lists, allPages] = data
          this.landPageList = allPages || []
          if (isArray(btns) && isArray(lists)) {
            this.playList = lists.map((ret) => {
              return { id: ret.play_id, name: ret.play_name }
            })
            this.playBtns = btns
          }
        })
        .catch((err) => console.log(err))
    },
    selectAccount(val) {
      const outterForm = Object.assign({}, this.outterForm)
      outterForm.externalUrls = val
      this.pageModal = false
      this.outterForm = outterForm
    },
    closePage() {
      this.pageModal = false
    },
    selectLinkLandPage(meta) {
      const innerForm = Object.assign({}, this.innerForm)
      innerForm.land_page_id = meta.land_page_id
      this.innerForm = innerForm
      this.linkModel = false
    },
    handlePlayable() {},
    /**
     * @description: 表单校验
     * @return {*} 成功promise.resolve 失败promise.reject
     */
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.appsetting.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('setting'))
          }
        })
      })
    }
  },
  created() {
    // 加载数据源
    this.preLoadData()
  }
}
</script>
<style lang="scss" scoped></style>
